import React from "react";
import icons from "@adl/asset-icons/dist/sprite.svg";
import { GlApp } from "@adl/component-app";
import { ABTestingProvider } from "@crystal/ab-testing";
import { ConfigProvider } from "@crystal/config";
import { Microfrontend, SvgSprite } from "@crystal/core";
import { FeatureFlagsProvider } from "@crystal/feature-flags";
import { TranslationsProvider } from "@crystal/translator";
import styles from "./adl-utils.module.scss.js";
import Consents from "./components/consents.js";
const FEATURE_FLAGS_PROJECT_NAME = "account-acquisition";
const TRANSLATIONS_PROJECT_NAME = "account-consents";
const TRANSLATIONS_NAMESPACE_NAME = "default";
const ConsentsWrapper = (props) => /* @__PURE__ */ React.createElement(ConfigProvider, { context: props.context }, /* @__PURE__ */ React.createElement(FeatureFlagsProvider, { context: props.context, projectName: FEATURE_FLAGS_PROJECT_NAME }, /* @__PURE__ */ React.createElement(ABTestingProvider, null, /* @__PURE__ */ React.createElement(
  TranslationsProvider,
  {
    context: props.context,
    project: TRANSLATIONS_PROJECT_NAME,
    namespace: TRANSLATIONS_NAMESPACE_NAME
  },
  /* @__PURE__ */ React.createElement(Consents, { ...props })
))));
const ConsentsProvider = (props) => /* @__PURE__ */ React.createElement(GlApp, { className: styles.adlUtils }, /* @__PURE__ */ React.createElement(Microfrontend, { ...props }, /* @__PURE__ */ React.createElement(SvgSprite, { id: "gl-theme-icons", source: icons }), /* @__PURE__ */ React.createElement(ConsentsWrapper, { ...props })));
export {
  ConsentsProvider,
  ConsentsWrapper
};
//# sourceMappingURL=ConsentsProvider.js.map
